/**
 * Feedback
 *
 *
 * @module kickstarter/AutoComplete
 */

"use strict";

import Request from "utils/Request";
import { elementValue } from "../../utils/html";
import GtmEvents from "../../utils/GtmEvents";

class AutoComplete {
    /**
     * @class AutoComplete
     * @constructor
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._timeoutId = 0;
        this._amount = 0;

        this._typedTextCache = "";
        this._typedText = "";
        this._activeElement = null;

        this.commonSearchKeywordJSON = window.commonSearchKeywordJSON;

        let datacx = document
            .querySelector("[data-cx]")
            .getAttribute("data-cx");
        const url = "//clients1.google.com/complete/search?";
        const params = "hl=en&client=partner-generic&sugexp=gsnos%2Cn%3D13&gs_rn=25&gs_ri=partner-generic&types=t&ds=cse&cp=5&gs_id=k"
        const partnerId = `&partnerid=${datacx}`;

        this._baseUrl = `${url}${params}${partnerId}`;

        this._form = this._element;
        this._searchBox = this._form.querySelector('[type="text"]');

        this._onkeyupBind = this._getMatches.bind(this);
        this._onFocusBind = this._getcommonSearchKeyword.bind(this);
        this._onClickBind = this._onClick.bind(this);
        this._onClickDocumentBind = this._onClickDocument.bind(this);

        window.addEventListener(
            "keyup",
            this._arrowNavigation.bind(this),
            false
        );

        this._initialize();
    }

    /**
     * Initialization method
     * @method _initialize
     * @private
     */
    _initialize() {
        this._searchBox.addEventListener("keyup", this._onkeyupBind);
        this._searchBox.focus();
        this._makeMeasurements();
    }

    /**
     * Check if we want to push events to Google
     */
    _makeMeasurements() {
        const value = elementValue(this._searchBox);

        // Query DOM outside of element for possible results
        const hasResults = document.querySelector(".search-list");

        value && !hasResults && this._pushNoResultsData(value);
    }

    /**
     * Push the no-results event to the data layer
     * @param {string} value
     */
    _pushNoResultsData(value) {
        GtmEvents.push({
            events: {
                category: "zoekfunctie",
                action: "geenResultaat",
                label: value
            },
            event: "interaction.zoekfunctie.geenResultaat"
        });
    }

    delay(ms) {
        clearTimeout(this._timeoutId);
        return new Promise(resolve => {
            this._timeoutId = setTimeout(resolve, ms); // (A)
        });
    }

    clearDelay() {
        clearTimeout(this._timeoutId);
    }

    _getMatches(e) {
        this._searchBox.removeEventListener("focus", this._onFocusBind);
        this._typedText = e.currentTarget.value.toLowerCase();

        if (this._typedText.length > 2) {
            if (this._typedText !== this._typedTextCache) {
                this._typedTextCache = this._typedText;
                this.delay(500).then(() => {
                    // result 0 dicht klappem
                    Request.JSONP(this._baseUrl, this._typedText).then(data => {
                        this._amount = 0;
                        this._buildDialog(data, this._typedText);
                    });
                });
            }
        } else {
            this.clearDelay();
            /*if(this._element.querySelector('.container')) {
                this._element.removeChild(this._element.querySelector('.container'));
            }*/
        }
    }

    _getcommonSearchKeyword(e) {
        e.preventDefault();
        e.stopPropagation();

        if (e.currentTarget.value.length === 0) {
            this._buildDialog(this.commonSearchKeywordJSON, "");
        }
    }

    _buildDialog(data, value) {
        if (data.length > 0) {
            let container =
                this._element.querySelector(".container") ||
                document.createElement("div");
            container.classList.add("container");
            container.setAttribute("tabindex", "-1");

            let list =
                this._element.querySelector(".list") ||
                document.createElement("ul");
            list.classList.add("list");
            container.appendChild(list);

            if (list.childNodes.length > 0) {
                list.innerHTML = "";
            }

            data.forEach(element => {
                var suggestion = document.createElement("li");
                list.appendChild(suggestion);

                var link = document.createElement("a");
                suggestion.appendChild(link);
                link.addEventListener("click", this._onClickBind);
                link.setAttribute("cleantext", element);
                if (value !== "") {
                    link.innerHTML = this._highlightMatch(element, value);
                } else {
                    link.innerHTML = element;
                }
                link.href = "#";
                link.setAttribute("tabindex", "-1");
            });

            this._setElementWidthToParentWidth(container, this._form);

            this._form.insertAdjacentElement('beforeend', container);

            document.addEventListener("click", this._onClickDocumentBind);
        }
    }

    _highlightMatch(text, match) {
        let regExp = new RegExp("(" + match + ")", "gi");
        return text.replace(regExp, "<strong>$1</strong>");
    }

    /**
     * Set element width to parent width
     * @param {HTMLElement} element
     * @param {HTMLElement} parent
     */
    _setElementWidthToParentWidth(element, parent) {
        const { width } = parent.getBoundingClientRect();
        element.style.width = `${width}px`;
    }

    _arrowNavigation(e) {
        let t = e.keyCode; // down= 40 up=38
        let container = this._form.querySelector(".container");

        if (t === 13) {
            if (this._activeElement !== null) {
                this._searchBox.value = this._activeElement.getAttribute(
                    "cleantext"
                );
                this._activeElement = null;
                this._submitForm();
            }
        }

        if (container !== null) {
            let elements = container.getElementsByTagName("a");
            let elementsLength = elements.length;
            this._activeElement = null;

            switch (t) {
                case 40:
                    // Do something for "down arrow" key press.
                    this.i = this._amount;

                    if (this.i < elementsLength) {
                        elements[this.i].classList.add("active");
                        this._activeElement = elements[this.i];
                        if (this.i > 0) {
                            elements[this.i - 1].classList.remove("active");
                        }
                        if (this.i < elementsLength - 1) {
                            this._amount = this.i;
                        }
                        this._amount++;
                    }
                    break;

                case 38:
                    // Do something for "up arrow" key press.
                    var j = this.i;
                    if (this.i > 0) {
                        this._amount = j - 1;
                        elements[this._amount].classList.add("active");
                        this._activeElement = elements[this._amount];
                        if (this.i <= elementsLength - 1) {
                            elements[this._amount + 1].classList.remove(
                                "active"
                            );
                        }

                        j = this.i--;
                    }
                    break;

                    return; // Quit when this doesn't handle the key event.
            }

            e.preventDefault();
        }
    }

    /**
     * Handles filling searchbox value when click event occurs
     * @private
     */
    _onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this._searchBox.value = e.currentTarget.getAttribute("cleantext");
        this._submitForm();
    }

    _onClickDocument(e) {
        if (e.target !== this._searchBox) {
            this.clearDelay();
            if (this._element.querySelector(".container")) {
                this._element.removeChild(
                    this._element.querySelector(".container")
                );
            }
        }
    }

    _submitForm() {
        this.delay(500).then(() => {
            this._form.submit();
        });
    }

    _onSubmit(e) {
        e.preventDefault();
    }

    /**
     * Unload and reset everything if conditions no longer apply.
     * @method unload
     * @public
     */
    unload() {}
}

export default AutoComplete;
